const EXPERIENCE_TYPE = {
    CURRENT: 'current',
    NEW: 'new'
};

const COLOR_SWATCH_DISPLAY = {
    CURRENT: 'current',
    SHOW_HYBRID: 'showHybrid'
};

const LARGER_PRODUCT_CARD_CAROUSEL = {
    CURRENT: 'current',
    NEW: 'largerCards'
};

const CLEAN_PRODUCTS_LINK_TYPE = {
    CURRENT: 'pageLink',
    NEW: 'modalLink'
};

const VIEW_FREQUENTLY_BOUGHT_TOGETHER = {
    CURRENT: 'useItWith',
    NEW: 'frequentlyBoughtTogether'
};

const VIEW_CLEAN_HIGHLIGHT_CERTONA_MODAL = {
    CURRENT: 'hideModal',
    NEW: 'showModal'
};

const LIMITED_TIME_OFFER = {
    EN: 'Limited Time Offer',
    FR: 'Offre d’une durée limitée'
};

const NEXT_DAY_DELIVERY_MESSAGE = {
    ORDER_NOW: 'Order now, get it tomorrow',
    ORDER_TODAY: 'Order today'
};

const ORDER_TYPE = {
    STANDARD: 'standard',
    BOPIS: 'bopis',
    SDD: 'sdd'
};

const SHOW_ML_DRIVEN_PROMOS = {
    CURRENT: 'hidePromos',
    NEW: 'showPromos'
};

const ATB_MODAL_CERTONA_BOPIS = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne'
};

const CERTONA_VS_ML = {
    CERTONA: 'certona',
    ML: 'ml'
};

const SIMPLIFY_SIGN_IN_ON_MAIN_NAV = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const COLLAPSE_PROMO_CODE_IN_CHECKOUT = {
    CONTROL: 'control',
    CHALLENGER: 'challenger'
};

const SHOW_ALT_IMAGE_ON_PRODUCT_TILES = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne'
};

const SHOW_FORCED_SIGN_IN_TOOLTIP = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const ENCOURAGE_SIGN_IN_ON_PPAGE = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

module.exports = {
    EXPERIENCE_TYPE,
    COLOR_SWATCH_DISPLAY,
    LARGER_PRODUCT_CARD_CAROUSEL,
    CLEAN_PRODUCTS_LINK_TYPE,
    VIEW_FREQUENTLY_BOUGHT_TOGETHER,
    VIEW_CLEAN_HIGHLIGHT_CERTONA_MODAL,
    LIMITED_TIME_OFFER,
    NEXT_DAY_DELIVERY_MESSAGE,
    ORDER_TYPE,
    SHOW_ML_DRIVEN_PROMOS,
    ATB_MODAL_CERTONA_BOPIS,
    CERTONA_VS_ML,
    SIMPLIFY_SIGN_IN_ON_MAIN_NAV,
    COLLAPSE_PROMO_CODE_IN_CHECKOUT,
    SHOW_ALT_IMAGE_ON_PRODUCT_TILES,
    SHOW_FORCED_SIGN_IN_TOOLTIP,
    ENCOURAGE_SIGN_IN_ON_PPAGE
};
